const getActionType = (action, formName) => `realhub/brandhub/form/${formName}/${action}`

export function createUpdateForm(formName){
  return param => ({
    type: getActionType('UPDATE', formName),
    payload: param,
  })
}

export function createResetForm(formName){
  return () => ({
    type: getActionType('RESET', formName),
  })
}

export default function reducer(formName, intialState = {}){
  const FORM_UPDATE = getActionType('UPDATE', formName)
  const FORM_RESET = getActionType('RESET', formName)

  return (state = intialState, action) => {
    const { type, payload } = action

    switch (type){
      case FORM_UPDATE:{
        const fieldKey = Object.keys(payload)[0]
        const value = payload[fieldKey]

        const isInitalValue = Object.prototype.hasOwnProperty.call(intialState, fieldKey)
        const isEmptyArray = Array.isArray(value) && !value.length
        const shouldFieldReset = !value || value === null || value === '' || isEmptyArray

        if (shouldFieldReset && !isInitalValue){
          const nextState = Object.assign({}, state)
          delete nextState[fieldKey]
          return nextState
        }

        return { ...state, ...payload }
      }
      case FORM_RESET:{
        return intialState
      }
      default:
        return state
    }
  }
}
